import { Briefcase, MapPin, Users, TrendingUp, Heart, Award } from 'lucide-react';
import { Link } from 'react-router-dom';

const TrabalheConoscoPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {/* Header */}
      <header className="absolute top-0 left-0 right-0 z-10 p-6">
        <div className="flex items-center">
          <img 
            src="/lovable-uploads/1f6dcb92-5dfc-4a75-aa2e-c3251eb28c93.png" 
            alt="Fox Vendas Logo" 
            className="h-12 w-auto"
          />
        </div>
      </header>

      {/* Hero Section */}
      <div className="relative px-4 pt-32 pb-32">
        <div className="max-w-7xl mx-auto text-center">
          {/* Título */}
          <div className="mb-8">
            <h1 className="text-5xl font-bold text-white mb-4">
              Fox <span className="text-orange-400">Talentos</span>
            </h1>
            <p className="text-xl text-gray-200 max-w-2xl mx-auto">
              Seja parte da equipe que está revolucionando o mercado imobiliário em Campinas e região
            </p>
          </div>

          {/* CTA Principal */}
          <div className="mb-16">
            <Link to="/vagas">
              <button className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-4 text-lg rounded-full shadow-2xl transform hover:scale-105 transition-all duration-300 flex items-center justify-center mx-auto">
                <Briefcase className="mr-2 h-6 w-6" />
                Ver Vagas Disponíveis
              </button>
            </Link>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-5xl mx-auto">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white">
              <div className="text-3xl font-bold text-orange-400 mb-2">200+</div>
              <div className="text-sm text-gray-200">Imóveis Vendidos</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white">
              <div className="text-3xl font-bold text-orange-400 mb-2">30+</div>
              <div className="text-sm text-gray-200">Corretores Ativos</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white">
              <div className="text-3xl font-bold text-orange-400 mb-2">4+</div>
              <div className="text-sm text-gray-200">Anos de Mercado</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 text-white">
              <div className="text-3xl font-bold text-orange-400 mb-2">2</div>
              <div className="text-sm text-gray-200">Unidades Ativas</div>
            </div>
          </div>
        </div>
      </div>

      {/* Por que trabalhar na Fox */}
      <div className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Por que escolher a Fox Vendas?
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Oferecemos muito mais que um emprego. Aqui você constrói uma carreira sólida no mercado imobiliário.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-purple-50 to-blue-50 rounded-xl p-8 text-center group hover:shadow-xl transition-all duration-300">
              <div className="bg-purple-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <TrendingUp className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Crescimento Acelerado</h3>
              <p className="text-gray-600">
                Plano de carreira estruturado com oportunidades reais de crescimento em uma empresa em expansão.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-8 text-center group hover:shadow-xl transition-all duration-300">
              <div className="bg-blue-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <Award className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Premiações & Reconhecimento</h3>
              <p className="text-gray-600">
                Sistema de premiações mensais, reconhecimento por performance e bônus por metas atingidas.
              </p>
            </div>

            <div className="bg-gradient-to-br from-indigo-50 to-purple-50 rounded-xl p-8 text-center group hover:shadow-xl transition-all duration-300">
              <div className="bg-indigo-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <Users className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Equipe Unida</h3>
              <p className="text-gray-600">
                Ambiente colaborativo, treinamentos constantes e mentoria de profissionais experientes.
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-teal-50 rounded-xl p-8 text-center group hover:shadow-xl transition-all duration-300">
              <div className="bg-green-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <MapPin className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Localização Estratégica</h3>
              <p className="text-gray-600">
                Escritórios em Campinas e Paulínia, próximos aos principais centros urbanos da região.
              </p>
            </div>

            <div className="bg-gradient-to-br from-yellow-50 to-orange-50 rounded-xl p-8 text-center group hover:shadow-xl transition-all duration-300">
              <div className="bg-yellow-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <Heart className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Treinamentos & Capacitação</h3>
              <p className="text-gray-600">
                Programa completo de desenvolvimento profissional com cursos, workshops e certificações para acelerar sua carreira.
              </p>
            </div>

            <div className="bg-gradient-to-br from-red-50 to-pink-50 rounded-xl p-8 text-center group hover:shadow-xl transition-all duration-300">
              <div className="bg-red-600 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                <Briefcase className="h-8 w-8 text-white" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">Tecnologia de Ponta</h3>
              <p className="text-gray-600">
                Ferramentas modernas, CRM completo e suporte de marketing digital para maximizar seus resultados.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Final */}
      <div className="bg-gradient-to-r from-gray-800 to-gray-900 py-20">
        <div className="max-w-4xl mx-auto text-center px-4">
          <h2 className="text-4xl font-bold text-white mb-6">
            Pronto para Decolar sua Carreira?
          </h2>
          <p className="text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
            Junte-se a nós e faça parte de uma equipe que valoriza seu crescimento e sucesso profissional.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/vagas">
              <button className="bg-orange-500 hover:bg-orange-600 text-white font-bold px-8 py-4 rounded-full flex items-center justify-center">
                <Briefcase className="mr-2 h-5 w-5" />
                Explorar Vagas
              </button>
            </Link>
            
            <button 
              className="border border-white text-white hover:bg-white hover:text-gray-800 px-8 py-4 rounded-full flex items-center justify-center transition-colors"
              onClick={() => {
                const element = document.getElementById('chat-button');
                if (element) element.click();
              }}
            >
              <Users className="mr-2 h-5 w-5" />
              Falar com RH
            </button>
          </div>
        </div>
      </div>

      {/* Depoimentos */}
      <div className="bg-gray-50 py-20">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              O que nossos colaboradores dizem
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="text-yellow-400 mb-4">★★★★★</div>
              <p className="text-gray-600 mb-6 italic">
                "A Fox me deu todas as ferramentas para crescer profissionalmente. Em 2 anos, tripleiquei minha renda e ganhei uma promoção."
              </p>
              <div className="font-semibold text-gray-900">Maria Santos</div>
              <div className="text-sm text-gray-500">Gerente de Vendas</div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="text-yellow-400 mb-4">★★★★★</div>
              <p className="text-gray-600 mb-6 italic">
                "Ambiente super colaborativo e equipe que realmente se preocupa com seu desenvolvimento. Recomendo demais!"
              </p>
              <div className="font-semibold text-gray-900">João Silva</div>
              <div className="text-sm text-gray-500">Corretor Sênior</div>
            </div>

            <div className="bg-white rounded-xl p-8 shadow-lg">
              <div className="text-yellow-400 mb-4">★★★★★</div>
              <p className="text-gray-600 mb-6 italic">
                "Comecei como estagiária e hoje sou analista. A Fox investe no crescimento dos colaboradores de verdade."
              </p>
              <div className="font-semibold text-gray-900">Ana Costa</div>
              <div className="text-sm text-gray-500">Analista de Marketing</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrabalheConoscoPage;